import styled from 'styled-components';
import { Link } from 'gatsby';

export const A = styled(Link)`
  display: block;
  visibility: hidden;
`;
